import React from 'react';
import { Form } from 'react-bootstrap';
import Feedback from './Feedback';

export interface HelperTextProps {
  /** 錯誤 style */
  error?: boolean;
  /** 說明文字 */
  helperText?: string;
}

const HelperText = (props: HelperTextProps): JSX.Element => {
  const { error, helperText } = props;

  if (helperText)
    return error ? (
      <Feedback type="invalid">{helperText}</Feedback>
    ) : (
      <Form.Text>{helperText}</Form.Text>
    );
  return <> </>;
};

export default HelperText;
